import { Settings, AutoAwesome, ExpandMore, ExpandLess, Contacts } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { ConfigurationType } from './types';

interface ConfigurationTitleProps {
  type: ConfigurationType;
  open: boolean;
  onClickCollapse: (open: boolean) => void;
}

const IconsMapper: Record<ConfigurationType, JSX.Element> = {
  [ConfigurationType.Setup]: <Settings sx={{ fontSize: '20px' }} />,
  [ConfigurationType.Facilities]: <AutoAwesome sx={{ fontSize: '20px' }} />,
  [ConfigurationType.Partners]: <Contacts sx={{ fontSize: '20px' }} />,
};

const TitleMapper: Record<ConfigurationType, string> = {
  [ConfigurationType.Setup]: 'Configurações',
  [ConfigurationType.Facilities]: 'Facilidades',
  [ConfigurationType.Partners]: 'Parceiros',
};

export const ConfigurationTitle = ({ type, open, onClickCollapse }: ConfigurationTitleProps): JSX.Element => (
  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
    <div>{IconsMapper[type]}</div>
    <div>{TitleMapper[type]}</div>
    <IconButton onClick={() => onClickCollapse(open)}>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
  </Box>
);

export default ConfigurationTitle;
